export const BR1173EventsRecord = [
    {
        eventName: 'Video_Click',
        description: '',
        meta: [],
        scope: [],
        check() {
            return true;
        },
        prepare(data) {
            const { eventName, sourceName } = data;
            return {
                ...data,
                source_name: sourceName,
                event: eventName,
            };
        },
    },
    /**
     * @event 'Romantic_Scroll'
     */
    {
        eventName: 'Romantic_Scroll',
        description: '',
        meta: [],
        scope: [],
        check() {
            return true;
        },
        prepare(data) {
            const { eventName, headerName } = data;
            return {
                ...data,
                event: eventName,
                header_name: headerName,
            };
        },
    },

    /**
     * @event 'Squid_game_Scroll'
     */
    {
        eventName: 'Squid_game_Scroll',
        description: '',
        meta: [],
        scope: [],
        check() {
            return true;
        },
        prepare(data) {
            const { eventName, headerName } = data;
            return {
                ...data,
                event: eventName,
                header_name: headerName,
            };
        },
    },
    /**
     * @event 'Squid_game_Click'
     */
    {
        eventName: 'Squid_game_Click',
        description: '',
        meta: [],
        scope: [],
        check() {
            return true;
        },
        prepare(data) {
            const { eventName, buttonName } = data;
            return {
                ...data,
                event: eventName,
                button_name: buttonName,
            };
        },
    },
    /**
     * @event 'Squid_game_Reviews_Click'
     */
    {
        eventName: 'Squid_game_Reviews_Click',
        description: '',
        meta: [],
        scope: [],
        check() {
            return true;
        },
        prepare(data) {
            const { eventName } = data;
            return {
                ...data,
                event: eventName,
            };
        },
    },
    /**
     * @event 'Squid_game_Video_Click'
     */
    {
        eventName: 'Squid_game_Video_Click',
        description: '',
        meta: [],
        scope: [],
        check() {
            return true;
        },
        prepare(data) {
            const { eventName } = data;
            return {
                ...data,
                event: eventName,
            };
        },
    },
    /**
     * @event 'Squid_game_Terms_Click'
     */
    {
        eventName: 'Squid_game_Terms_Click',
        description: '',
        meta: [],
        scope: [],
        check() {
            return true;
        },
        prepare(data) {
            const { eventName } = data;
            return {
                ...data,
                event: eventName,
            };
        },
    },
    /**
     * @event 'Squid_game_Menu_Click'
     */
    {
        eventName: 'Squid_game_Menu_Click',
        description: '',
        meta: [],
        scope: [],
        check() {
            return true;
        },
        prepare(data) {
            const { eventName } = data;
            return {
                ...data,
                event: eventName,
            };
        },
    },
    /**
     * @event 'Squid_game_Dish_Click'
     */
    {
        eventName: 'Squid_game_Dish_Click',
        description: '',
        meta: [],
        scope: [],
        check() {
            return true;
        },
        prepare(data) {
            const { eventName } = data;
            return {
                ...data,
                event: eventName,
            };
        },
    },
];
